var error = "https://shopfront-cdn.tekoapis.com/static/0e3c0ac5500f8b8c.svg";

export { error as default };
